<div class="white-wrap-admin mb-4">
  <div class="back-link-outer">
    <div class="back-link-outer mb-3 d-flex">
      <a role="button" (click)="goBack()" class="back-link">
        <img alt="back" src="../assets/images/back.svg" /> back
      </a>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-md-12">
      <p class="body-txt-22 mb-4">View Registered Users</p>
    </div>

    <div class="col-12 col-md-12">
      <div class="form-group m-0">
        <div class="mat-field-width">
          <div class="custom-select-option custom-select-wrap">
            <mat-form-field appearance="outline">
              <mat-label>Select Auction To View Its Results</mat-label>
              <mat-select
                [(value)]="auctionId"
                (selectionChange)="onAuctionChange($event.value)"
              >
                <mat-option
                  *ngFor="let auction of auctionsDD"
                  [value]="auction.value"
                  >{{ auction.text }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="grey-well m-0">
        <div class="for-badge mb-2">
          <span class="card-badge badge-dark">{{
            auctionData?.saleType?.publicName
          }}</span>
        </div>
        <h1 class="well-name mb-2">{{ auctionData?.title }}</h1>
        <h3 class="well-des" [innerHTML]="auctionData?.tagline"></h3>
      </div>
    </div>
  </div>
</div>

<div class="page-title-wrap mb-3 mb-md-4">
  <h1 class="hdg m-0">Registered Users</h1>
</div>

<section class="table-search-wrap mb-1 pb-2">
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="row">
        <div class="col-8 pr-0">
          <div class="form-group">
            <search-control
              [placeholder]="'Search'"
              (value)="changeSearchValue($event)"
            >
            </search-control>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-container *ngIf="totalCount === 0; else showTable">
  <div class="empty-state-container empty-pad-2">
    <div class="empty-state-content">
      <img
        alt="empty-state"
        src="../../../../assets/images/empty-state-icon.svg"
      />
      <h3 class="_heading">No User Found</h3>
    </div>
  </div>
</ng-container>

<ng-template #showTable>
  <div class="data-table-wrap">
    <app-paginator
      [paginationId]="'server'"
      [currentPage]="pageNumber"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      *ngIf="totalCount > pageSize"
    ></app-paginator>

    <table
      mat-table
      aria-label="table"
      [dataSource]="
        auctionUsers
          | paginate
            : {
                id: 'server',
                itemsPerPage: pageSize,
                currentPage: pageNumber,
                totalItems: totalCount
              }
      "
      class="mat-elevation-z8 custom-data-table ImportRegisteredUsers m-0"
    >
      <!-- Position Column -->
      <ng-container matColumnDef="bidderNum">
        <th
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="column-1 listing-header-name"
        >
          Bidder Number
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="column-1 listing-data-entry"
          data-column="Bidder Number"
        >
          <span> {{ element.paddleNumber | isEmpty }} </span>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="column-2 listing-header-name"
        >
          Name & Email
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="column-2 listing-data-entry"
          data-column="Name & Email"
        >
          <div class="emailAddressOuter">
            <span
              >{{ element.user.firstName + " " + element.user.lastName }}
            </span>
            <p class="emailAddress m-0">
              <a href="mailto:{{ element.user.email }}">
                {{ element.user.email }}
              </a>
            </p>
          </div>
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="company">
        <th
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="column-3 listing-header-name"
        >
          Company
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="column-3 listing-data-entry"
          data-column="Company"
        >
          <span>{{ element.user.companyName | isEmpty }}</span>
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="spendHistory">
        <th
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="column-4 listing-header-name"
        >
          Spending History
          <span
            #tooltip="matTooltip"
            class="ml-1"
            matTooltipClass="custom-tooltip-icon custom-tooltip-max"
            matTooltip="The Spending History reflects the sum of the Successful/Winning Max Bids a user has placed in the Online Auction System."
            [matTooltipPosition]="'above'"
          >
            <img alt="info" src="../assets/images/info.svg" />
          </span>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="column-4 listing-data-entry"
          data-column="Spending History"
        >
          <span>{{
            !element.isNewToPlatform
              ? (element.spendingHistory | currency: "USD")
              : "-"
          }}</span>
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="status">
        <th
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="column-5 listing-header-name"
        >
          New ?
          <span
            #tooltip="matTooltip"
            class="ml-1"
            matTooltipClass="custom-tooltip-icon custom-tooltip-max"
            matTooltip="Is the user being added for the first time on TBG platform ?"
            [matTooltipPosition]="'above'"
          >
            <img alt="info" src="../assets/images/info.svg" />
          </span>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="column-5 listing-data-entry"
          data-column="New ?"
        >
          <span> {{ element.isNewToPlatform ? "Yes" : "No" }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <app-paginator
      [paginationId]="'server'"
      [currentPage]="pageNumber"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      *ngIf="totalCount > pageSize"
    ></app-paginator>
  </div>
</ng-template>
